<template>
    <a class="btn font-semibold" :class="classes" :style="style">
        <!-- <fa-icon :icon="['fab', brand]" size2="2x" class="mr-1" /> -->
        <i :class="[iconClass, `fa-${brand}`, `btn-${brand}`, {'mr-1': size !== 'lg'}, {'mr-2': size === 'lg'}]" class="fa-lg"></i>
        <slot />
    </a>
</template>

<script>
export default {
    props: {
        brand: {
            type: String,
            required: true
        },
        size: {
            type: String,
            default: null
        },
        block: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({}),

    created() {},

    mounted() {},

    computed: {
        isBlock() {
            return this.block === true;
        },

        isDark() {
            if (this.brand === 'discord') {
                return true;
            }

            return false;
        },

        iconClass() {
            if (this.brand === 'envelope') {
                return 'far';
            }

            return 'fab';
        },

        classes() {
            return {
                'btn-sm': this.size === 'sm',
                'btn-lg': this.size === 'lg',
                'btn-light': !this.isDark,
                'btn-dark' : this.isDark,
                'btn-block': this.isBlock
            };
        },

        style() {
            var style = {};
            if (this.brand === 'discord') {
                style['background-color'] = "#5c7cfa";
                style['border-color'] = "#4a63c8";
                style['color'] = "#fff";
            }
            if (this.brand === 'google') {
                style['background-color'] = '#f6faff';
                style['color'] = '#3c4043';
            }

            return style;
        }
    },

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
